<template>
  <div v-if="display" :class="className()">
    <div class="stat-description-wrapper">
      <div class="stat-description">{{ description }}</div>
      <div class="icon-and-tooltip">
        <font-awesome-icon
          :icon="['far', 'question-circle']"
          :style="{ color: '#919EAB', 'margin-left': '0.5rem' }"
        >
        </font-awesome-icon>
        <md-tooltip class="tooltip" md-direction="top">{{ tooltip }}</md-tooltip>
      </div>
    </div>
    <div class="stat-value">{{ formatter(value) }}</div>
  </div>
</template>

<script>
export default {
  name: 'StatDisplay',
  props: {
    description: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '0',
    },
    formatter: {
      type: Function,
      default: x => x,
    },
    bottomBorder: {
      type: Boolean,
      default: false,
    },
    display: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    className() {
      if (this.bottomBorder) {
        return 'stat bottomBorder'
      }

      return 'stat'
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip {
  background-color: black;
  color: white;
}

.stat {
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.bottomBorder {
  border-bottom-style: solid;
  border-bottom-color: #dfdfe0;
  border-bottom-width: 1px;
}

.stat-description-wrapper {
  display: flex;
  flex-direction: row;
}

.md-tooltip {
  height: auto;
  white-space: normal;
  font-size: 12px;
  max-width: 300px;
}
</style>
